import NextLink from 'next/link';
import { Box, BoxProps } from '@mui/material';
import { NextImage } from '@sdf/base';

interface Props extends BoxProps {
  link?: string;
  disabledLink?: boolean;
  width?: number;
  height?: number;
  onlyLogo?: boolean;
}

const Logo: React.FC<Props> = ({
  link = '/',
  disabledLink = false,
  width = 42,
  height = 42,
  sx,
  onlyLogo,
  ...other
}) => {
  const logo = (
    <NextImage
      src={onlyLogo ? '/assets/logo.svg' : '/assets/logoWithText.svg'}
      alt="Logo"
      width={width}
      height={height}
      style={{ cursor: 'pointer', borderRadius: '0px !important' }}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <NextLink href={link} passHref>
      {logo}
    </NextLink>
  );
};

export default Logo;
